import timeClock from './timeClock';

export default {
	timeClockPage: timeClock
}